/* ============================================================
   INDSO — product.js
   Refactored from the static product.js to operate on
   server-rendered Liquid markup (real product media, variants).
   Gallery, accordions, before/after slider, sticky bar, video.
   ============================================================ */
(function () {
  'use strict';

  const ready = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  /* ===== GALLERY (thumbnails swap the main image) ===== */
  function initGallery() {
    const main = document.getElementById('mainImg');
    const strip = document.getElementById('thumbStrip');
    if (!main || !strip) return;
    const thumbs = Array.from(strip.querySelectorAll('.tb'));
    if (thumbs.length === 0) return;
    let gi = 0;

    function select(i) {
      gi = (i + thumbs.length) % thumbs.length;
      const t = thumbs[gi];
      const full = t.dataset.full;
      if (full) main.src = full;
      const alt = t.dataset.alt;
      if (alt !== undefined) main.alt = alt;
      thumbs.forEach((el, n) => el.classList.toggle('on', n === gi));
      t.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => select(i)));
    const prev = document.getElementById('tprev');
    const next = document.getElementById('tnext');
    if (prev) prev.addEventListener('click', () => select(gi - 1));
    if (next) next.addEventListener('click', () => select(gi + 1));
  }

  /* ===== ACCORDIONS ===== */
  function initAccordions() {
    document.querySelectorAll('.acc .acc-head').forEach((head) => {
      head.addEventListener('click', () => {
        const acc = head.closest('.acc');
        const body = acc.querySelector('.acc-body');
        const open = acc.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    });
    document.querySelectorAll('.acc.open .acc-body').forEach((b) => {
      b.style.maxHeight = b.scrollHeight + 'px';
    });
  }

  /* ===== BEFORE / AFTER SLIDER ===== */
  function initBeforeAfter() {
    const range = document.getElementById('baRange');
    const afterWrap = document.getElementById('afterWrap');
    const handle = document.getElementById('baHandle');
    if (!range || !afterWrap || !handle) return;
    const set = (v) => { afterWrap.style.width = v + '%'; handle.style.left = v + '%'; };
    range.addEventListener('input', (e) => set(e.target.value));
    set(range.value || 50);
  }

  /* ===== STICKY ADD TO CART ===== */
  function initStickyBar() {
    const bar = document.getElementById('stickybar');
    const top = document.getElementById('pdpTop');
    if (!bar || !top || !('IntersectionObserver' in window)) return;
    bar.classList.remove('show');
    let active = false;
    setTimeout(() => { active = true; }, 300);
    const io = new IntersectionObserver(
      (entries) => { if (active) bar.classList.toggle('show', !entries[0].isIntersecting); },
      { rootMargin: '0px 0px -85% 0px' }
    );
    io.observe(top);

    // sticky "Add to Cart" mirrors the main product form
    const stickyBtn = bar.querySelector('[data-sticky-add]');
    const mainForm = document.getElementById('product-form');
    if (stickyBtn && mainForm) {
      stickyBtn.addEventListener('click', () => {
        mainForm.querySelector('[type="submit"]').click();
      });
    }
  }

  /* ===== VIDEO click-to-play ===== */
  function initVideo() {
    const frame = document.getElementById('pframe');
    if (!frame) return;
    frame.addEventListener('click', () => {
      const embed = frame.dataset.embed;
      if (embed) {
        frame.innerHTML =
          '<iframe width="100%" height="100%" src="' + embed +
          '" title="Product video" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen style="position:absolute;inset:0;width:100%;height:100%"></iframe>';
      }
    });
  }

  /* ===== VARIANT PICKER ===== */
  function initVariants() {
    const form = document.getElementById('product-form');
    if (!form) return;
    const root = document.querySelector('[data-product-json]');
    if (!root) return;
    let variants = [];
    try { variants = JSON.parse(root.textContent); } catch (e) { return; }

    const idInput = form.querySelector('[name="id"]');
    const selectors = Array.from(document.querySelectorAll('[data-option-selector]'));
    const priceNow = document.querySelector('[data-price-now]');
    const priceWas = document.querySelector('[data-price-was]');
    const addBtn = form.querySelector('[data-add-btn]');
    const stickyBtn = document.querySelector('[data-sticky-add]');

    // Keep the sticky bar button in sync with the main add button's state.
    function syncSticky(available) {
      if (!stickyBtn) return;
      stickyBtn.disabled = !available;
      stickyBtn.classList.toggle('is-soldout', !available);
      stickyBtn.textContent = available
        ? (stickyBtn.dataset.label || 'Add to Cart')
        : (stickyBtn.dataset.soldout || 'Sold out');
    }

    // No option selectors = single/no-variant product. Trust the server-rendered
    // button state (driven by product.available) and do nothing further.
    if (selectors.length === 0) {
      if (addBtn) syncSticky(!addBtn.disabled);
      return;
    }

    function currentOptions() {
      return selectors.map((s) => {
        if (s.type === 'radio' || s.type === 'checkbox') {
          const checked = document.querySelector(`[name="${s.name}"]:checked`);
          return checked ? checked.value : null;
        }
        return s.value;
      });
    }

    function findVariant(opts) {
      return variants.find((v) =>
        Array.isArray(v.options) &&
        v.options.length === opts.length &&
        v.options.every((o, i) => o === opts[i])
      );
    }

    function money(cents) {
      return (window.Shopify && window.Shopify.moneyFormat)
        ? window.Shopify.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
        : '₹' + (cents / 100).toFixed(2);
    }

    function update() {
      const opts = currentOptions();
      const variant = findVariant(opts);
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.unavailable || 'Unavailable';
        }
        syncSticky(false);
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = money(variant.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (addBtn.dataset.label || 'Add to Cart')
          : (addBtn.dataset.soldout || 'Sold out');
      }
      syncSticky(variant.available);
    }

    selectors.forEach((s) => s.addEventListener('change', update));
    update();
  }

  /* ===== MOBILE GALLERY (full-width swipe + dots) ===== */
  function initMobileGallery() {
    const slider = document.getElementById('gmobile');
    const dotsWrap = document.getElementById('gmobileDots');
    if (!slider || !dotsWrap) return;
    const dots = Array.from(dotsWrap.querySelectorAll('.gmobile__dot'));
    if (dots.length === 0) return;

    let raf = null;
    slider.addEventListener('scroll', () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = null;
        const i = Math.round(slider.scrollLeft / slider.clientWidth);
        dots.forEach((d, n) => d.classList.toggle('on', n === i));
      });
    });
  }

  ready(() => {
    initGallery();
    initMobileGallery();
    initAccordions();
    initBeforeAfter();
    initStickyBar();
    initVideo();
    initVariants();
  });
})();
